/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * Identifies which pre-built sandbox dataset to generate for a company.
 */
export type SandboxDataSet = typeof SandboxDataSet[keyof typeof SandboxDataSet];


export const SandboxDataSet = {
  FinanceHrAdministration: 'FinanceHrAdministration',
  It: 'It',
  HospitalityRecreation: 'HospitalityRecreation',
  MarketingCommunication: 'MarketingCommunication',
  SalesProcurement: 'SalesProcurement',
  PolicyOrganization: 'PolicyOrganization',
  Healthcare: 'Healthcare',
  TechProductionLogistics: 'TechProductionLogistics',
  MatchingEvaluation: 'MatchingEvaluation',
} as const;
